export default "__VITE_ASSET__bjFK6MJg__"